import { FolderCog } from "lucide-react"
import { langStore } from "@/stores/lang-store"

const groupManageBundle = {
  title: {
    ko: "그룹 관리",
    en: "Manage Groups",
    es: "Gestionar grupos"
  }
}

const GroupManageButton = ({ onClick }) => {
  const { lang } = langStore()

  return (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex shrink-0 items-center gap-2 rounded-xl border border-slate-200 bg-white px-2 md:px-3.5 py-2 text-sm font-semibold text-slate-600 transition-colors hover:border-slate-300 hover:bg-slate-100"
    >
      <FolderCog size={16} strokeWidth={2} aria-hidden="true" />
      <span className="hidden md:block">{groupManageBundle.title[lang]}</span>
    </button>
  )
}

export default GroupManageButton
